import {CRS} from "leaflet";
import { StateService, StateParams } from "@uirouter/angularjs";
import {CmdCenterSiteAreaModel} from "../../models/cmd/CmdCenterSiteAreaModel";
import {LatLngZoom, MapDefaults} from "../../libs/LeafletHelper";
import L from "leaflet";

export class CmdCenterSiteAreaCtrl {
    map:any;
    defaults:MapDefaults = new MapDefaults(false,CRS.Simple,10,-5);
    center:LatLngZoom = new LatLngZoom(0,0,0);
    layers:any = [];
    imageLayer:any = null;
    selectedMapAreaWatch:any;
    selectedMapSiteWatch:any;
    public static $inject = ['$scope', '$state', '$stateParams',"leafletData", 'CmdCenterSiteAreaModel'];
    constructor(public $scope:any, public stateService:StateService,
                public stateParamsService:StateParams,
                public leafletData:any,
                public model:CmdCenterSiteAreaModel) {
        $scope.vm = this;
        var mapSiteId = stateParamsService["mapSiteID"];
        var mapAreaId = stateParamsService["mapAreaid"];
        this.model.init(mapSiteId, mapAreaId).then(()=>{
            return this.leafletData.getMap("siteAreaMap");
        })
        .then((map)=> {
            this.map = map;
            //this.setImage();
            L.control.mousePosition().addTo(map);
            this.selectedMapAreaWatch = this.$scope.$watch(()=>this.model.selectedMapArea,(oldVal:any,newVal:any)=>{
              if(oldVal != newVal)
                this.setImage();
            });
            this.selectedMapSiteWatch = this.$scope.$watch(()=>this.model.selectedMapSite,(oldVal:any,newVal:any)=>{
              if(oldVal != newVal)
                this.model.updateMapAreas(this.model.selectedMapSite);
            });
            this.setImage();
        });
    }
    setImage(){
      var aoeua = 3;
      var aoeua88 = 3;
      if(this.imageLayer != null){
        this.map.removeLayer(this.imageLayer);
      }
      if(this.model.selectedMapArea == null)
        return;
      this.model.getMapAreaImage().then((ok)=>{
        var fdid= this.model.selectedMapArea.fileDataID;
        var height= this.model.selectedMapArea.imageHeight;
        var width= this.model.selectedMapArea.imageWidth;
        var imgUrl = "data:image/png;base64,"+this.model.imageData;
        this.imageLayer = L.imageOverlay(imgUrl, [[0,0],[-1*height,width]]).addTo(this.map);
        //this.imageLayer = L.imageOverlay(this.model.getBaseUrl()+"/getImage?id="+fdid, [[0,0],[-1*height,width]]).addTo(this.map);
        this.imageLayer.bringToBack();
      });
    }
    addSite(){
        this.stateService.go("cmdcenter.editsite");
    }
    editSite(){
        if(this.model.selectedMapSite != null)
            this.stateService.go("cmdcenter.editsite",{"id":this.model.selectedMapSite.id});
    }
    deleteSite(){
        this.model.deleteSite().then((success)=>{
            this.model.updateMapAreas(this.model.selectedMapSite);
            this.setImage();
        });
    }
    addArea(){
        if(this.model.selectedMapSite != null)
            this.stateService.go("cmdcenter.editarea",{"mapSiteID":this.model.selectedMapSite.id});
    }
    editArea(){
        if(this.model.selectedMapSite != null)
            this.stateService.go("cmdcenter.editarea",{"id":this.model.selectedMapArea.id,"mapSiteID":this.model.selectedMapSite.id});
    }
    deleteArea(){
        this.model.deleteArea().then((success)=>{
            this.setImage();
        });
    }
}
